import { memo } from 'react';
import classNames from 'classnames';

import { ReactComponent as BronzeMedal } from '~/assets/images/collections/bronze-medal.svg';
import { ReactComponent as GoldMedal } from '~/assets/images/collections/gold-medal.svg';
import { ReactComponent as SilverMedal } from '~/assets/images/collections/silver-medal.svg';

import styles from './RankingMedalIcon.module.scss';

function RankingMedalIcon({
  place,
  className,
}: {
  place: number;
  className: string;
}): JSX.Element {
  if (place === 1) {
    return <GoldMedal className={classNames(styles.gold, className)} />;
  }
  if (place === 2) {
    return <SilverMedal className={classNames(styles.silver, className)} />;
  }

  return <BronzeMedal className={classNames(styles.bronze, className)} />;
}

export default memo(RankingMedalIcon);
